import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class VersionInfo  {
    _originalTypeClassName = "zAppDevManager.BO.VersionInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
VersionInfo.translate = translateService;
}
this.Name = null;
this.Description = null;
this.Changes = null;
this.ReleaseDate = null;
this.VersionInfoKey = null;
this._key = this.VersionInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Description:any;
Changes:any;
ReleaseDate:any;
private _VersionInfoKey:any;
get VersionInfoKey(): any {
    return this._VersionInfoKey;
  }
set VersionInfoKey(value: any) {
    this._VersionInfoKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.VersionInfoKey == null || $this.VersionInfoKey == 0;
            }


}